import React from 'react';

import { SupportedLanguage } from 'lib/lexemes/supported-languages';

import FaqAccordion from 'components/faq/faq-accordian';
import UiFaqContainer from 'components/faq/faq-list';
import { StructuredData } from 'components/structured-data';
import { P2 } from 'components/typography';

type Props = {
  title: string;
  lang?: SupportedLanguage;
  content?: {
    question: string;
    answer: string;
    extraClass?: string;
  }[];
  id?: string;
};

const FaqContainer: React.FC<Props> = ({ title, content, id }) => {
  return (
    <UiFaqContainer title={title}>
      {content ? (
        <>
          {content.map((faq, index) => (
            <FaqAccordion
              title={faq.question}
              content={<P2 html={faq.answer} as="p" />}
              extraClass={faq.extraClass}
              key={index}
            />
          ))}
          {
            <StructuredData
              id={id || 'faq-page'}
              type={StructuredData.type.FAQPage}
              data={{
                items: content?.map(({ question, answer }) => {
                  return {
                    name: question,
                    item: answer,
                  };
                }),
              }}
            />
          }
        </>
      ) : null}
    </UiFaqContainer>
  );
};

export { FaqContainer };
export default FaqContainer;
